( function( $, window, document, undefined ) {

	//var navigation = '';
	// Check JavaScript is available.
	//if ( element.classList.contains( 'js' ) ) {
	//}

	// Add `.is-closed` modifier to navigation on page load.
	$( document ).ready(function() {
		$( '.navigation--primary .menu' ).toggleClass( 'is-closed' );
	});

	$( document ).ready(function() {
		$( '.js-menu-navigation-primary' ).click(function() {
			$( '.navigation--primary .menu' ).toggleClass( 'is-closed' );
			event.preventDefault();
		});
	});

})( jQuery, window, document );
 
